<template>
  <v-app>
    <v-app-bar app color="primary" dark elevation="2">
      <v-toolbar-title class="d-flex align-center">
        <img src="/assets/logo.png" alt="DriveAdv" height="40" class="mr-2" />
        <span class="text-h5 font-weight-bold">DriveAdv</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Navigation Menu -->
      <template v-if="isAuthenticated">
        <v-btn
          v-if="canViewChannels"
          text
          :to="{ name: 'Channels' }"
          class="mx-1"
        >
          <v-icon left>mdi-television</v-icon>
          Channels
        </v-btn>

        <v-btn
          v-if="canViewCampaigns"
          text
          :to="{ name: 'Campaigns' }"
          class="mx-1"
        >
          <v-icon left>mdi-bullhorn</v-icon>
          Campaigns
        </v-btn>

        <v-btn
          v-if="isAdmin"
          text
          :to="{ name: 'Users' }"
          class="mx-1"
        >
          <v-icon left>mdi-account-multiple</v-icon>
          Users
        </v-btn>

        <v-divider vertical class="mx-2"></v-divider>

        <v-btn text @click="logout">
          <v-icon left>mdi-logout</v-icon>
          Logout
        </v-btn>
      </template>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <v-footer app color="grey lighten-4" elevation="2">
      <v-col class="text-center" cols="12">
        <span class="grey--text text--darken-1">
          &copy; {{ new Date().getFullYear() }} DriveAdv Admin UI v2.0
        </span>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    userRole() {
      return this.currentUser?.role || null;
    },
    isAdmin() {
      return this.userRole === 'administrator';
    },
    canViewChannels() {
      // ACL: publishers, administrators
      return this.userRole === 'publisher' || this.userRole === 'administrator';
    },
    canViewCampaigns() {
      // ACL: advertisers, administrators
      return this.userRole === 'advertiser' || this.userRole === 'administrator';
    },
  },
  methods: {
    async logout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="less">
// Global styles will be loaded from main.less

.v-toolbar-title img {
  filter: brightness(0) invert(1); // Make logo white in dark toolbar
  object-fit: contain;
}
</style>

